import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bell",
  "use": "icon-bell-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bell\"><path d=\"M793.389 806.69h120.208a37.087 37.087 0 0 0 0-74.218h-53.159V445.217a356.307 356.307 0 0 0-267.843-345.132 89.043 89.043 0 1 0-176.75 0 356.307 356.307 0 0 0-267.71 345.132v287.255H103.88a37.087 37.087 0 1 0 0 74.217h149.771v-0.133H793.39v0.133z m-422.69 83.745a134.945 134.945 0 0 0 267.13 0H370.7z\" p-id=\"4796\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol